import { CONSTANTS } from "../constants/gameConstants";

// Get a random edge position for enemy spawn
export function getRandomEdgePosition(width: number, height: number, margin: number = 30) {
  const edge = Math.floor(Math.random() * 4);
  switch (edge) {
    case 0: return { x: Math.random() * width, y: margin };
    case 1: return { x: width - margin, y: Math.random() * height };
    case 2: return { x: Math.random() * width, y: height - margin };
    case 3: return { x: margin, y: Math.random() * height };
    default: return { x: width / 2, y: height / 2 };
  }
}

// Troop merging logic
export function getMergeType(type1: string, type2: string): string | null {
  const typesToMatch = [type1, type2].sort();
  for (const [mergedType, components] of Object.entries(CONSTANTS.MERGE_COMBINATIONS)) {
    const sortedComponents = [...(components as string[])].sort();
    if (sortedComponents.length === 2 && sortedComponents[0] === typesToMatch[0] && sortedComponents[1] === typesToMatch[1]) {
      return mergedType;
    }
  }
  return null;
}

export function canMergeTroops(type1: string, type2: string): boolean {
  return getMergeType(type1, type2) !== null;
}

// Weighted random enemy type
export function getRandomEnemyType(wave: number): string {
  const types: { type: string; weight: number; minWave?: number }[] = [
    { type: "basic", weight: 40 },
    { type: "fast", weight: 18 },
    { type: "tank", weight: 12, minWave: 2 },
    { type: "swarm", weight: 20, minWave: 3 },
    { type: "brute", weight: 10, minWave: 5 },
  ];
  const available = types.filter(t => !t.minWave || wave >= t.minWave);
  const total = available.reduce((sum, t) => sum + t.weight, 0);
  const r = Math.random() * total;
  let acc = 0;
  for (const t of available) {
    acc += t.weight;
    if (r < acc) return t.type;
  }
  return "basic";
}
